import { map, Observable, switchMap } from 'rxjs';
import {
  CreateWa_AutomationTaskMutation,
  CreateWa_AutomationTaskMutationVariables,
  DeleteWa_AutomationTaskMutation,
  DeleteWa_AutomationTaskMutationVariables,
  GetWa_AutomationTaskQuery,
  GetWa_AutomationTaskQueryVariables,
  ListWa_AutomationTasksQuery,
  ListWa_AutomationTasksQueryVariables,
  RunWa_AutomationTaskMutation,
  RunWa_AutomationTaskMutationVariables,
  UpdateWa_AutomationTaskMutation,
  UpdateWa_AutomationTaskMutationVariables,
} from '../../../../graphql/generatedModel';
import { Pub, Service, Sub } from '../../../../shared/services/service.abstract';
import {
  createAutomationTask,
  deleteAutomationTask,
  getAutomationTask,
  listAutomationTasks,
  runAutomationTask,
  updateAutomationTask,
} from './gql/automation.gql';
import { gqlClient } from '../../../../graphql/graphqlRequest';

class PubImpl extends Pub<Actions> {
  listTasks(params?: ListWa_AutomationTasksQueryVariables) {
    this.emit('listTasks', params);
  }
  getTask(params: GetWa_AutomationTaskQueryVariables) {
    this.emit('getTask', params);
  }
  createTask(params: CreateWa_AutomationTaskMutationVariables) {
    this.emit('createTask', params);
  }
  updateTask(params: UpdateWa_AutomationTaskMutationVariables) {
    this.emit('updateTask', params);
  }
  deleteTask(params: DeleteWa_AutomationTaskMutationVariables) {
    this.emit('deleteTask', params);
  }
  runTask(params: RunWa_AutomationTaskMutationVariables) {
    this.emit('runTask', params);
  }
}

class SubImpl extends Sub<Actions> {
  listTasks(): Observable<ListTasksRes> {
    return this.actionListener('listTasks').pipe(
      switchMap(
        ({ params }) =>
          gqlClient(listAutomationTasks, params) as Observable<ListWa_AutomationTasksQuery>,
      ),
      map((res) => res.wawiAssist?.listWA_AutomationTasks as ListTasksRes),
    );
  }

  getTask(): Observable<GetTaskRes> {
    return this.actionListener('getTask').pipe(
      switchMap(
        ({ params }) =>
          gqlClient(getAutomationTask, params) as Observable<GetWa_AutomationTaskQuery>,
      ),
      map((res) => res.wawiAssist?.getWA_AutomationTask as GetTaskRes),
    );
  }

  createTask(): Observable<CreateTaskRes> {
    return this.actionListener('createTask').pipe(
      switchMap(
        ({ params }) =>
          gqlClient(createAutomationTask, params) as Observable<CreateWa_AutomationTaskMutation>,
      ),
      map((res) => res.wawiAssist?.createWA_AutomationTask as CreateTaskRes),
    );
  }

  updateTask(): Observable<UpdateTaskRes> {
    return this.actionListener('updateTask').pipe(
      switchMap(
        ({ params }) =>
          gqlClient(updateAutomationTask, params) as Observable<UpdateWa_AutomationTaskMutation>,
      ),
      map((res) => res.wawiAssist?.updateWA_AutomationTask as UpdateTaskRes),
    );
  }

  deleteTask(): Observable<DeleteTaskRes> {
    return this.actionListener('deleteTask').pipe(
      switchMap(
        ({ params }) =>
          gqlClient(deleteAutomationTask, params) as Observable<DeleteWa_AutomationTaskMutation>,
      ),
      map((res) => res.wawiAssist?.deleteWA_AutomationTask as DeleteTaskRes),
    );
  }

  runTask(): Observable<RunTaskRes> {
    return this.actionListener('runTask').pipe(
      switchMap(
        ({ params }) =>
          gqlClient(runAutomationTask, params) as Observable<RunWa_AutomationTaskMutation>,
      ),
      map((res) => res.wawiAssist?.runWA_AutomationTask as RunTaskRes),
    );
  }
}

class AutomationService extends Service<Actions> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export type ListTasksRes = NonNullable<
  NonNullable<ListWa_AutomationTasksQuery['wawiAssist']>['listWA_AutomationTasks']
>;
type GetTaskRes = NonNullable<
  NonNullable<GetWa_AutomationTaskQuery['wawiAssist']>['getWA_AutomationTask']
>;
export type CreateTaskRes = NonNullable<
  NonNullable<CreateWa_AutomationTaskMutation['wawiAssist']>['createWA_AutomationTask']
>;
export type UpdateTaskRes = NonNullable<
  NonNullable<UpdateWa_AutomationTaskMutation['wawiAssist']>['updateWA_AutomationTask']
>;
export type DeleteTaskRes = NonNullable<
  NonNullable<DeleteWa_AutomationTaskMutation['wawiAssist']>['deleteWA_AutomationTask']
>;
export type RunTaskRes = NonNullable<
  NonNullable<RunWa_AutomationTaskMutation['wawiAssist']>['runWA_AutomationTask']
>;

export const automationService = new AutomationService();

type Actions =
  | 'listTasks'
  | 'getTask'
  | 'createTask'
  | 'updateTask'
  | 'deleteTask'
  | 'runTask'
  | undefined;
